import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '../tooltip';

import styles from './styles.module.scss';

const cx = (...classes) => classes?.filter(c => !!c).join(' ');

/**
 * Search input field.
 *
 * @param {*} props
 */
const SearchField = ({ classes, ...props }) => {
    return (
        <Paper className={cx(styles.paper, classes.paper)}>
            <Tooltip title="Search" aria-label="search">
                <IconButton
                    type="submit"
                    className={cx(
                        styles.iconButton,
                        classes.button,
                        styles.searchIcon
                    )}
                    aria-label="search"
                    role="button"
                >
                    <SearchIcon />
                </IconButton>
            </Tooltip>
            <Autocomplete
                open
                classes={{
                    root: styles.input
                }}
                className={styles.autoComplete}
                renderInput={params => (
                    <InputBase
                        classes={{
                            root: cx(styles.input, classes.input),
                            input: classes.inputElement
                        }}
                        ref={params.InputProps.ref}
                        inputProps={params.inputProps}
                        placeholder={props.placeholder}
                    />
                )}
                {...props}
            />
            {props.value && (
                <Tooltip title="Clear search" aria-label="clear search">
                    <IconButton
                        className={cx(
                            styles.iconButton,
                            classes.button,
                            styles.clearIcon
                        )}
                        aria-label="cancel"
                        role="button"
                        disableRipple
                        disableFocusRipple
                        onClick={props.onClear}
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Paper>
    );
};

SearchField.propTypes = {
    onClear: () => {},
    placeholder: PropTypes.string,
    value: PropTypes.string,
    classes: PropTypes.shape({
        paper: PropTypes.string,
        input: PropTypes.string,
        inputElement: PropTypes.string,
        button: PropTypes.string
    })
};

SearchField.defaultProps = {
    onClear: PropTypes.func,
    classes: {},
    placeholder: '',
    value: ''
};

export default SearchField;
